import { useQuery } from '@tanstack/react-query';
import { apiWrapper } from '@/apiWrapper';
import { getEndpoints } from '@/endpoints';
import type { Destination } from '@/features/destinations/utils/Destination';

const getDestinations = async (
  useNewDest?: boolean,
): Promise<Destination[]> => {
  const url = getEndpoints().destinations;
  const config = {
    method: 'GET',
    params: useNewDest ? { useNewDest: 'true' } : undefined,
  };

  return await apiWrapper<Destination[]>(url, config);
};

export const useDestinations = (
  useNewDest?: boolean,
  featureFlagsReady?: boolean,
) => {
  return useQuery({
    queryKey: ['destinations', useNewDest],
    queryFn: () => getDestinations(useNewDest),
    staleTime: Number.POSITIVE_INFINITY,
    enabled: featureFlagsReady !== false,
  });
};
